var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.influencer)?_c('div',{staticClass:"text-center my-3"},[_c('div',{staticClass:"influencer-logo"},[_c('v-img',{attrs:{"src":_vm.logo}})],1),_c('div',{staticClass:"influencer-name"},[_vm._v("Shop with "+_vm._s(_vm.influencer.name))]),_c('div',{staticClass:"influencer-code"},[_vm._v("Code: "+_vm._s(_vm.influencer.code))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }